module.exports = __webpack_public_path__ + "static/img/user.37885a6e.png";